import React, { useContext } from "react";
import { Divider } from "antd";
import { PendingTableCellContext } from "../../ChemBioPendingContext";
import GenistaIDList from "./GenistaIDList";

const GenistaIDListWithTitle = ({
  testList,
  instrumentName,
  index,
}) => (
  <>
    <div className={`PendingTable__GenistaCell__AnalyzeContainer ${index > 0 ? "PendingTable__GenistaCell--margin-top" : ""}`}>
      <b>{instrumentName}</b>
      <Divider className={`PendingTable__CheckboxContainer__Divider${testList.length === 0 ? "--no-data" : ""}`} />
    </div>
    <GenistaIDList testList={testList} />
  </>
);

const MrlCellContent = () => {
  const {
    mrlInstruments,
    testList,
  } = useContext(PendingTableCellContext);
  const allInstrumentNames = mrlInstruments.map((item) => item.instrument_name).join(" & ");
  const listMap = {
    no_instruments: [],
    4: [],
    5: [],
    "-1": [],
  };
  // Create three list based on the loaded_on_instruments value
  testList.forEach((testItem) => {
    const { loaded_on_instruments } = testItem;
    if (loaded_on_instruments.length === 1) {
      if (loaded_on_instruments.includes(4)) {
        listMap["4"].push(testItem); // GC-MS
      } else if (loaded_on_instruments.includes(5)) {
        listMap["5"].push(testItem); // LS-MS
      }
    } else if (loaded_on_instruments.length === 2) {
      listMap["-1"].push(testItem); // GC-MS & LC-MS
    } else if (loaded_on_instruments.length === 0) {
      listMap.no_instruments.push(testItem);
    }
  });
  const mrlLists = [...mrlInstruments, { instrument_name: allInstrumentNames, id: -1 }];
  /** Only render the section if the test list length > 0 */
  const sections = [];
  if (listMap.no_instruments.length > 0) {
    sections.push({ instrument_name: "No Instrument", targetList: listMap.no_instruments });
  }
  mrlLists.forEach((item) => {
    const targetList = listMap[String(item.id)];
    if (targetList && targetList.length > 0) {
      sections.push({ ...item, targetList });
    }
  });

  return (sections.map((item, index) => (
    <GenistaIDListWithTitle
      key={index}
      testList={item.targetList}
      instrumentName={item.instrument_name}
      index={index}
    />
  )));
};

export default MrlCellContent;
